import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import LaptopImg from "../../assets/home-main.svg";
import Tilt from "react-parallax-tilt";
import AnimatedSection from "../AnimatedSection";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const iconHover = {
  scale: 1.1,
  y: -3,
  transition: { type: "spring", stiffness: 400, damping: 15 },
};

const About = () => {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <AnimatedSection direction="up" delay={0}>
              <h1 style={{ fontSize: "2.6em" }}>
                LET ME <span className="yellow"> INTRODUCE </span> MYSELF
              </h1>
              <div className="section-divider" style={{ margin: "16px auto 0" }}></div>
            </AnimatedSection>

            <AnimatedSection direction="up" delay={0.15}>
              <p className="home-about-body">
                Highly skilled{" "}
                <span className="yellow">Full-Stack AI Engineer</span> with
                over 7 years of experience in designing, developing, and
                deploying scalable applications across modern technology stacks.
              </p>
            </AnimatedSection>

            <AnimatedSection direction="up" delay={0.25}>
              <p className="home-about-body" style={{ paddingTop: 0 }}>
                Proficient in{" "}
                <span className="yellow">
                  Java, Spring Boot, Spring Data JPA, Spring AI, MySQL,
                </span>{" "}
                and cloud-native DevOps, with expertise in{" "}
                <span className="yellow">
                  LLM integration, RAG systems, and AI-powered microservices.
                </span>
              </p>
            </AnimatedSection>

            <AnimatedSection direction="up" delay={0.35}>
              <p className="home-about-body" style={{ paddingTop: 0 }}>
                Experienced in building intelligent, high-performance web
                applications using <span className="yellow">React</span> and
                delivering end-to-end AI-driven solutions from data ingestion to
                production deployment.
              </p>
            </AnimatedSection>

            <AnimatedSection direction="up" delay={0.45}>
              <p className="home-about-body" style={{ paddingTop: 0 }}>
                Strong background in software architecture, system design, and
                distributed computing, with a proven ability to lead
                cross-functional teams, ensure security, performance, and
                maintainability, and deliver robust, production-ready solutions
                in fast-paced, innovation-driven environments.
              </p>
            </AnimatedSection>
          </Col>
          <Col md={4} className="myAvtar">
            <AnimatedSection direction="right" delay={0.3}>
              <Tilt>
                <img src={LaptopImg} className="img-fluid" alt="avatar" />
              </Tilt>
            </AnimatedSection>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <AnimatedSection direction="up" delay={0.2}>
              <h1>FIND ME ON</h1>
              <p>
                Please don't hesitate to reach out to me and{" "}
                <span className="yellow">connect.</span>
              </p>
            </AnimatedSection>
            <AnimatedSection direction="up" delay={0.3}>
              <ul className="home-about-social-links">
                <li className="social-icons">
                  <motion.a
                    href="https://github.com/buntychakraborty"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                    aria-label="github"
                    whileHover={iconHover}
                  >
                    <AiFillGithub />
                  </motion.a>
                </li>

                <li className="social-icons">
                  <motion.a
                    href="https://www.linkedin.com/in/bunty-chakraborty-b5a395119/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                    aria-label="linkedin"
                    whileHover={iconHover}
                  >
                    <FaLinkedinIn />
                  </motion.a>
                </li>
              </ul>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default About;
